var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hight-light',{attrs:{"is-bg":true,"text":"优益优加智慧书院"}}),_vm._l((_vm.introduces),function(item){return _c('introduce',{key:item.title,attrs:{"is-left":item.isLeft,"text":item.text,"title":item.title,"img":item.img,"contact":item.contact,"is-white":item.isWhite}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }